"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function parseDimensionValue(value) {
    const parsedValue = value === undefined ? NaN : parseInt(value);
    if (Number.isNaN(parsedValue) || parsedValue <= 0) {
        return undefined;
    }
    else {
        return parsedValue;
    }
}
exports.parseDimensionValue = parseDimensionValue;
//# sourceMappingURL=parse-dimension-value.js.map